"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FragmentsLoader = void 0;
const fragments_prefetcher_1 = require("./fragments-prefetcher");
const fragments_module_wrapper_1 = require("./fragments-module-wrapper");
const fragments_dev_tools_1 = require("./fragments-dev-tools");
const array_1 = require("./utils/array");
class FragmentsLoader {
    constructor(discoveryServiceUrl, options) {
        this.discoveryServiceUrl = discoveryServiceUrl;
        this.options = options;
        this.prefetcher = new fragments_prefetcher_1.FragmentsPrefetcher();
        this.moduleWrapper = new fragments_module_wrapper_1.FragmentsModuleWrapper();
        this.devTools = new fragments_dev_tools_1.FragmentsDevTools();
        this.isInitialized = false;
        this.fragmentsInfo = {};
    }
    async initialize() {
        if (this.isInitialized) {
            return;
        }
        this.initializationPromise = this.initializeFragmentsInfo();
        await this.initializationPromise;
    }
    async initializeFragmentsInfo() {
        const url = `${this.discoveryServiceUrl}/modules?_=${+new Date()}`;
        const response = await fetch(url);
        const fragmentListResult = await response.json();
        this.fragmentsInfo = (0, array_1.convertArrayToObjectByKey)(fragmentListResult, 'name');
        if (this.options) {
            this.devTools.overrideFragmentsInfo(this.fragmentsInfo, this.options);
        }
        this.isInitialized = true;
    }
    async loadFragment(fragmentName) {
        if (!this.isInitialized) {
            await this.initializationPromise;
        }
        const fragmentInfo = this.getFragmentInfo(fragmentName);
        if (!fragmentInfo) {
            throw new Error(`[FragmentsLoader] Information about the requested fragment is missing in discovery service: [${fragmentName}]`);
        }
        if (fragmentInfo.module) {
            return fragmentInfo.module;
        }
        if (fragmentInfo.loadingPromise) {
            return fragmentInfo.loadingPromise;
        }
        fragmentInfo.loadingPromise = this.resolveModule(fragmentInfo.files, fragmentName);
        const module = await fragmentInfo.loadingPromise;
        fragmentInfo.module = module;
        return module;
    }
    async loadModule(moduleName) {
        const module = await this.loadFragment(moduleName);
        return module === null || module === void 0 ? void 0 : module.default;
    }
    getFragmentInfo(fragmentName) {
        return this.fragmentsInfo[fragmentName];
    }
    prefetchFragments(prefetchSettings) {
        this.prefetcher.prefetchFragments(this.fragmentsInfo, prefetchSettings);
    }
    async resolveModule(moduleFiles, fragmentName) {
        const styleFiles = moduleFiles.filter(fileUrl => new URL(fileUrl).pathname.endsWith('.css'));
        await this.loadStyles(styleFiles);
        const scriptFiles = moduleFiles.filter(fileUrl => new URL(fileUrl).pathname.endsWith('.js'));
        const mainScriptFileUrl = scriptFiles.find(fileUrl => new URL(fileUrl).pathname.indexOf('chunk-vendor') === -1);
        const vendorScripts = scriptFiles.filter(fileUrl => fileUrl !== mainScriptFileUrl);
        await this.loadScripts(vendorScripts);
        const [fragmentModule] = await this.loadScripts([mainScriptFileUrl]);
        return this.moduleWrapper.wrapModule(fragmentModule, fragmentName);
    }
    async loadStyles(files = []) {
        return Promise.all(files.map(async (fileUrl) => {
            const styles = await this.importFile(fileUrl);
            document.adoptedStyleSheets.push(styles.default);
        }));
    }
    async loadScripts(files = []) {
        const scripts = [];
        for (const fileUrl of files) {
            scripts.push(await this.importFile(fileUrl));
        }
        return scripts;
    }
    importFile(fileUrl) {
        if (!window.System) {
            throw new Error('[FragmentsLoader] SystemJS is not initialized. ' +
                'Please add SystemJS script initialization to page <head> section');
        }
        return window.System.import(fileUrl);
    }
}
exports.FragmentsLoader = FragmentsLoader;
